import React from "react";

export const ModalButton = props => <button {...props} className={'w-20 p-2 bg-middle/70 hover:bg-ptext/10 ' +
    'text-lg border-ptext/10 border-2 rounded-2xl ' + props.className} />